import { mutate } from "swr";

/**
 * Creates a function that revalidates ALL SWR caches for a given survey.
 * Matches both array-keyed useSWR hooks and string-keyed useSWRInfinite pages.
 *
 * @param {string} surveyId - The survey nanoid
 * @returns {Function} Call to revalidate all survey-related SWR caches
 */
export const createSurveyCacheInvalidator = (surveyId) => () => {
    const prefix = `/v2/survey/${surveyId}`;
    // Revalidate without clearing cached data. Passing `undefined` as the
    // second argument would wipe the cache, causing components that guard on
    // `survey` being truthy (e.g. build.js early-return) to unmount and lose
    // all local state. Calling mutate(matcher) with no data keeps existing
    // cached values while refetching in the background.
    mutate(
        (key) => {
            if (typeof key === "string" && key.startsWith(prefix)) return true;
            if (Array.isArray(key) && typeof key[0] === "string" && key[0].startsWith(prefix)) return true;
            return false;
        }
    ).catch((err) => console.warn("Survey cache revalidation failed:", err));
};
